import { SVGProps, Ref, forwardRef } from 'react';

export const StackoverflowGrayscaleSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="m10.709 10.939-6.11-1.284.257-1.222 6.11 1.285z" fill="#919191" />
            <path d="M11.067 9.365 5.407 6.73l.528-1.132 5.66 2.635z" fill="#919191" />
            <path d="M11.772 7.948 6.974 3.953l.799-.96L12.57 6.99z" fill="#919191" />
            <path d="M9.069 1.745 10.07 1l3.725 5.01-1.001.745z" fill="#919191" />
            <path d="M10.707 12.512h-6.22v-1.244h6.22z" fill="#919191" />
            <path d="M13.195 10.025H11.95v3.731H3.244v-3.732H2V15h11.195z" fill="#919191" />
        </svg>
    )
);
StackoverflowGrayscaleSize16Glyph.displayName = 'StackoverflowGrayscaleSize16Glyph';
